<template>
  <div class="free-trial-notice-parts">
    <p class="free-trial-notice-parts__catch">
      {{ $tc('SignupPage.SelectPlanPage.FreeTrialNotice.catch') }}
    </p>
    <p class="free-trial-notice-parts__content">
      <span class="free-trial-notice-parts__content__text">{{
        $tc('SignupPage.SelectPlanPage.FreeTrialNotice.content')
      }}</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'FreeTrialNoticeParts',
})
</script>

<style scoped lang="scss">
.free-trial-notice-parts {
  text-align: center;
  color: #000;

  &__catch {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.04em;
    white-space: pre-wrap;
  }

  &__content {
    margin-top: 14px;
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.04em;
    white-space: pre-wrap;

    &__text {
      position: relative;
      display: inline-block;
      padding: 3px 2px 5px;
      background-color: #00dba6;

      &::before {
        position: absolute;
        top: 0;
        left: -14px;
        width: 14px;
        height: 100%;
        content: '';
        background-color: #00dba6;
        clip-path: polygon(100% 0, 100% 100%, 0 100%);
      }

      &::after {
        position: absolute;
        top: 0;
        right: -14px;
        width: 14px;
        height: 100%;
        content: '';
        background-color: #00dba6;
        clip-path: polygon(0 0, 100% 0, 0 100%);
      }
    }
  }
}
</style>
